"use strict";
//todo duration and delay support
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var omi_1 = require("omi");
var TransitionGroup = /** @class */ (function (_super) {
    __extends(TransitionGroup, _super);
    function TransitionGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TransitionGroup.prototype.install = function () {
        //@ts-ignore 不是 slot，所以需要共享一下 host 的 css
        this.css = omi_1.getHost(this).constructor.css;
    };
    TransitionGroup.prototype.installed = function () {
        var _this = this;
        if (this.props.appear) {
            this.shadowRoot.childNodes.forEach(function (node, index) {
                _this.appearing(node, index);
            });
        }
    };
    TransitionGroup.prototype.appearing = function (el, index) {
        el.classList.add(this.props.name + '-appear');
        el.classList.add(this.props.name + '-appear-active');
        this.callback = function () {
            el.classList.remove(this.props.name + '-appear-to');
            el.classList.remove(this.props.name + '-appear-active');
        }.bind(this);
        this.elOnce(el, 'transitionend', this.callback);
        this.elOnce(el, 'animationend', this.callback);
        window.setTimeout(function () {
            el.classList.remove(this.props.name + '-appear');
            el.classList.add(this.props.name + '-appear-to');
        }.bind(this), index * this.props.delay);
    };
    TransitionGroup.prototype.receiveProps = function () {
        var _this = this;
        //find the leave item
        var el;
        var vel;
        var insertIndex;
        var arr = [];
        this.shadowRoot.childNodes.forEach(function (node) {
            if (node['__omiattr_'] && node['__omiattr_'].hasOwnProperty('key')) {
                arr.push(node);
            }
        });
        var vnodes = this.render(this.props);
        var len = vnodes.length;
        //insert
        if (len > arr.length) {
            for (var i = 0; i < len; i++) {
                if (i === len - 1) {
                    vel = vnodes[i];
                    insertIndex = i;
                    break;
                }
                else if (vnodes[i].attributes.key !== arr[i]['__omiattr_'].key) {
                    vel = vnodes[i];
                    insertIndex = i;
                    break;
                }
            }
        }
        else if (len < arr.length) { //delete
            for (var i = 0; i < arr.length; i++) {
                if (i === arr.length - 1) {
                    el = arr[i];
                }
                else if (vnodes[i].attributes.key !== arr[i]['__omiattr_'].key) {
                    el = arr[i];
                    break;
                }
            }
        }
        if (el) {
            // bind end event and trigger this.update()
            this.callback = function () {
                el.parentNode.removeChild(el);
                this.update();
            }.bind(this);
            this.elOnce(el, 'transitionend', this.callback);
            this.elOnce(el, 'animationend', this.callback);
            // add leave class
            el.classList.add(this.props.name + '-leave');
            el.classList.add(this.props.name + '-leave-active');
            window.setTimeout(function () {
                el.classList.remove(_this.props.name + '-leave');
                el.classList.add(_this.props.name + '-leave-to');
            }, 0);
        }
        else if (vel) {
            var iel_1 = omi_1.render(vel, null);
            // bind end event and trigger this.update()
            this.callback = function () {
                //@ts-ignore
                this.shadowRoot.removeChild(iel_1);
                this.update();
            }.bind(this);
            this.elOnce(iel_1, 'transitionend', this.callback);
            this.elOnce(iel_1, 'animationend', this.callback);
            insertChildAtIndex(this.shadowRoot, iel_1, insertIndex + 1);
            iel_1.classList.add(this.props.name + '-enter');
            iel_1.classList.add(this.props.name + '-enter-active');
            window.setTimeout(function () {
                iel_1.classList.remove(_this.props.name + '-enter');
                iel_1.classList.add(_this.props.name + '-enter-to');
            }, 0);
        }
        return false;
    };
    TransitionGroup.prototype.once = function (name, callback) {
        var wrapCall = function () {
            this.removeEventListener(name, wrapCall);
            callback();
        }.bind(this);
        this.addEventListener(name, wrapCall);
    };
    TransitionGroup.prototype.elOnce = function (el, name, callback) {
        var wrapCall = function () {
            el.removeEventListener(name, wrapCall);
            callback();
        }.bind(el);
        el.addEventListener(name, wrapCall);
    };
    TransitionGroup.prototype.render = function (props) {
        return props.children;
    };
    TransitionGroup.propTypes = {
        name: String,
        appear: Boolean,
        show: Boolean,
        remove: Boolean,
        delay: Number
    };
    TransitionGroup.defaultProps = {
        name: 'm',
        appear: false,
        show: false
    };
    TransitionGroup = __decorate([
        omi_1.tag('m-transition-group')
    ], TransitionGroup);
    return TransitionGroup;
}(omi_1.WeElement));
exports.default = TransitionGroup;
function insertChildAtIndex(parent, child, index) {
    if (!index)
        index = 0;
    if (index >= parent.children.length) {
        parent.appendChild(child);
    }
    else {
        parent.insertBefore(child, parent.children[index]);
    }
}
